import { animate, query, stagger, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SignupWizardService } from '@app/modules/user/signup/signup-wizard.service';

@Component({
  standalone: false,
  selector: 'sbnb-signup-trial',
  templateUrl: './signup-trial.component.html',
  styleUrls: ['./signup-trial.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('fadeInItems', [
      transition('void => *', [
        query('.trial-item', [
          style({ opacity: 0, transform: 'translateY(-50px)' }),
          stagger('200ms', [
            animate('500ms cubic-bezier(0.35, 0, 0.25, 1)', style({ opacity: 1, transform: 'translateY(0)' })),
          ]),
        ]),
      ]),
    ]),
  ],
})
export class SignupTrialComponent {
  constructor(private wizard: SignupWizardService) { }

  next() {
    this.wizard.next();
  }
}
